export const DEFAULT_SUPER_ADMIN_ROLE_ID = 1;
export const DEFAULT_NURSE_ROLE_ID = 2;
export const DEFAULT_COURIER_ROLE_ID = 5;
export const DEFAULT_HEALTH_ORG_ADMIN_ROLE_ID = 11;
export const DEFAULT_LABORATORY_ADMIN_ROLE_ID = 3;

export const Prefix = [
  { id: 1, label: "Mr", value: "Mr" },
  { id: 2, label: "Ms", value: "Ms" },
  { id: 3, label: "Mrs", value: "Mrs" },
];

export const adminPrefix = [
  { id: 1, label: "Mr", value: "Mr" },
  { id: 2, label: "Ms", value: "Ms" },
  { id: 3, label: "Dr", value: "Dr" },
  { id: 4, label: "Prof", value: "Prof" },
  { id: 5, label: "A/Prof", value: "A/Prof" },
];

export const surgeonPrefix = [
  { id: 1, label: "Dr.", value: "Dr." },
  { id: 2, label: "Prof.", value: "Prof." },
  { id: 3, label: "A/Prof.", value: "A/Prof." },
];

export const specimenStorage = [
  { id: 1, label: "Basket", value: "Basket" },
  { id: 2, label: "Fridge", value: "Fridge" },
  { id: 3, label: "Freezer", value: "Freezer" },
];

export const requestFormStatus = [
  { id: 1, label: "IN OT DROP OFF PENDING", value: "IN OT DROP OFF PENDING" },
  { id: 2, label: "READY FOR PICKUP", value: "READY FOR PICKUP" },
  { id: 3, label: "IN TRANSIT", value: "IN TRANSIT" },
  { id: 4, label: "RECEIVED BY LAB", value: "RECEIVED BY LAB" },
  { id: 5, label: "NO SPECIMEN", value: "NO SPECIMEN" },
];
